// eslint-disable-next-line import/prefer-default-export
export const BUTTON_TEXT = Object.freeze({
  PRODUCT_ONLY: 'Add Device Only',
  PRODUCT_AND_INSTALL: 'Add Installation Bundle',
  PRODUCT_SPECIALIST_CHAT: 'Talk to a product specialist',
});
